import ApiService from "../util/api.service";
import { SERVICE_CONFIG_URLS } from "./config";

const AuthService = {
    login,
    register,
    forgetPassword,
    emailVerification,
    resetPassword,
    verifyOtp,
};

async function login(payload) {
    const response = await ApiService.post(
        SERVICE_CONFIG_URLS.AUTH.LOGIN,
        payload
    );
    return response;
}

async function forgetPassword(payload) {
    const response = await ApiService.post(
        SERVICE_CONFIG_URLS.AUTH.FORGET_PASSWORD,
        payload
    );
    return response;
}

async function verifyOtp(payload) {
    const response = await ApiService.post(
        SERVICE_CONFIG_URLS.AUTH.VERIFY_OTP,
        payload
    );
    return response;
}

async function register(payload) {
    const response = await ApiService.post(
        SERVICE_CONFIG_URLS.AUTH.REGISTER,
        payload
    );
    return response;
}

async function emailVerification(token) {
    const url = `${SERVICE_CONFIG_URLS.AUTH.EMAIL_VARIFICATION}?token=${token}`;
    const response = await ApiService.patch(url);
    return response;
}

async function resetPassword(payload) {
    const response = await ApiService.post(
        SERVICE_CONFIG_URLS.AUTH.RESET_PASSWORD,
        payload
    );
    return response;
}

export default AuthService;
